import React from 'react';
import LegalPageLayout from '../../components/legal/LegalPageLayout';

export const PrivacyPolicyPage = () => {
  return (
    <LegalPageLayout title="Gizlilik Politikası" enTitle="Privacy Policy" updatedAt="11 Ağustos 2026">
      <p className="legal-intro">
        Martinci İmza Yönetim Portalı ("Martinci", "biz") olarak gizliliğinize önem veriyoruz. Bu
        politika, hizmetimizi kullanırken hangi verileri topladığımızı, bunları nasıl kullandığımızı
        ve nasıl koruduğumuzu açıklar. KVKK kapsamındaki haklarınız için{' '}
        <a href="/kvkk-aydinlatma-metni">KVKK Aydınlatma Metni</a>'ni de inceleyebilirsiniz.
      </p>

      <h2>1. Topladığımız Veriler</h2>
      <h3>Doğrudan sağladığınız veriler</h3>
      <ul>
        <li>Kayıt sırasında: ad, soyad, e-posta adresi, organizasyon adı, şifre.</li>
        <li>İmza şablonu oluştururken: unvan, telefon, adres gibi imzada görünmesini istediğiniz bilgiler.</li>
        <li>Destek talebinde bulunduğunuzda paylaştığınız bilgiler.</li>
      </ul>
      <h3>Bağlantı kurduğunuzda otomatik olarak alınan veriler</h3>
      <ul>
        <li>Microsoft 365 veya Google Workspace bağlantısı kurulduğunda, organizasyonunuzun dizin bilgileri (personel listesi, grup üyelikleri) — sadece dizin sağlayıcının verdiği okuma izni kapsamında.</li>
        <li>Oturum ve kullanım kayıtları: giriş zamanı, IP adresi, tarayıcı bilgisi.</li>
      </ul>

      <h2>2. Verilerinizi Nasıl Kullanıyoruz</h2>
      <p>Topladığımız verileri şu amaçlarla kullanırız:</p>
      <ul>
        <li>Hesabınızı oluşturmak ve yönetmek,</li>
        <li>E-posta imza şablonlarını organizasyonunuzun personeline doğru şekilde eşleştirip dağıtmak,</li>
        <li>Ödeme işlemlerini gerçekleştirmek (PAYTR üzerinden — kart bilgileriniz bize hiç ulaşmaz),</li>
        <li>Hizmeti geliştirmek, hataları tespit etmek ve gidermek,</li>
        <li>Güvenliği sağlamak ve kötüye kullanımı önlemek.</li>
      </ul>
      <p>Verilerinizi hiçbir şekilde reklam amacıyla üçüncü taraflara satmıyor veya kiralamıyoruz.</p>

      <h2>3. Verilerin Paylaşılması</h2>
      <p>Verileriniz yalnızca aşağıdaki durumlarda, hizmetin işleyişi için gerekli ölçüde paylaşılır:</p>
      <ul>
        <li><strong>Microsoft / Google:</strong> organizasyonunuzun bağladığı dizin sağlayıcısıyla, sadece o sağlayıcının API'leri üzerinden okuma amaçlı.</li>
        <li><strong>PAYTR:</strong> ödeme işlemlerinin yürütülmesi için.</li>
        <li><strong>Altyapı sağlayıcıları:</strong> sunucu ve barındırma hizmeti aldığımız taraflar, yalnızca teknik işletim amacıyla.</li>
        <li>Yasal bir zorunluluk hâlinde yetkili resmî makamlarla.</li>
      </ul>

      <h2>4. Veri Güvenliği</h2>
      <p>Verilerinizi korumak için aldığımız önlemlerden bazıları:</p>
      <ul>
        <li>Tüm bağlantılar HTTPS üzerinden şifrelenir.</li>
        <li>Microsoft/Google bağlantı anahtarları (client secret, refresh token) veritabanında şifrelenmiş olarak saklanır.</li>
        <li>Şifreniz asla düz metin olarak saklanmaz, tek yönlü hash'lenir.</li>
        <li>Kart bilgileriniz bizim sunucularımıza hiç ulaşmaz — doğrudan PAYTR'nin PCI-DSS uyumlu altyapısına iletilir.</li>
        <li>Erişim, rol bazlı yetkilendirme ile organizasyon sınırları içinde tutulur — bir organizasyonun verisi başka bir organizasyondan izole edilir.</li>
      </ul>

      <h2>5. Veri Saklama Süresi</h2>
      <p>
        Verilerinizi, hesabınız aktif olduğu sürece ve hesap kapatıldıktan sonra yasal
        yükümlülüklerimizi yerine getirmek için gereken makul süre boyunca saklarız. Bu sürenin
        sonunda veriler silinir veya geri döndürülemez şekilde anonimleştirilir.
      </p>

      <h2>6. Haklarınız</h2>
      <p>
        Verilerinize erişme, düzeltme, silme talep etme ve işlenmesine itiraz etme hakkına
        sahipsiniz. Detaylar için <a href="/kvkk-aydinlatma-metni">KVKK Aydınlatma Metni</a>'ne
        bakabilir veya doğrudan <a href="mailto:destek@martinci.com">destek@martinci.com</a> adresiyle
        iletişime geçebilirsiniz.
      </p>

      <h2>7. Çerezler</h2>
      <p>
        Hizmetimizde kullanılan çerez ve benzeri teknolojiler hakkında detaylı bilgi için{' '}
        <a href="/cerez-politikasi">Çerez Politikası</a>'nı inceleyebilirsiniz.
      </p>

      <h2>8. Bu Politikadaki Değişiklikler</h2>
      <p>
        Bu politikayı zaman zaman güncelleyebiliriz. Önemli değişikliklerde sizi e-posta yoluyla
        veya hizmet içinde bilgilendireceğiz.
      </p>
    </LegalPageLayout>
  );
};

export default PrivacyPolicyPage;
